import trace from '~/lib/trace';
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {View, ActivityIndicator} from 'react-native';
import {Divider} from 'react-native-paper';

import sy from '~/styles';
import {Text} from '~/components/controls';
import {
  service_request as serviceRequestApi,
  rob as robApi,
} from '~/api/private';
import {isRobTaskApproved} from '~/types/rob';

const ServiceHistory = ({request_id, license, history_service_request_id}) => {
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState(null);
  const [robComponents, setRobComponents] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      const {result: history} = await serviceRequestApi.fetch_history(
        request_id,
        history_service_request_id,
      );

      setHistory(history);

      const rob_codes = history.map((item) => item.rob_code);
      const {result: rob_components} = await robApi.all_components(
        request_id,
        rob_codes,
      );
      setRobComponents(rob_components);

      setLoading(false);
    };

    fetch().catch(trace);
  }, [request_id, history_service_request_id, license]);

  return loading ? (
    <ActivityIndicator color="#231fda" />
  ) : (
    <>
      {history
        ?.filter((item) => isRobTaskApproved(item.status))
        .sort((a, b) => {
          if (!a.rob_code && b.rob_code) {
            return 1;
          }

          if (!b.rob_code && a.rob_code) {
            return -1;
          }

          if (a.rob_code && b.rob_code) {
            return a.rob_code.localeCompare(b.rob_code);
          }

          return a.description.localeCompare(b.description);
        })
        .map((item, index, arr) => {
          const rowKey = `${item.service_request_id ?? 'rob'}-${
            item.rob_code ?? item.operation ?? item.description
          }`;

          return (
            <React.Fragment key={rowKey}>
              <View style={[sy['p-4'], sy['flex-row'], sy['gap-5']]}>
                <Text>{item.rob_code}</Text>
                <View style={[sy['flex-1']]}>
                  <Text>{item.description}</Text>
                  <Text style={[sy.smallRegular, sy['text-lightgray']]}>
                    {robComponents[item.rob_code]?.operations.find(
                      (x) => x.operation.code === item.operation,
                    )?.operation?.description ?? item.operation}
                  </Text>
                </View>
              </View>
              {index < arr.length - 1 && <Divider style={sy['bg-gray95']} />}
            </React.Fragment>
          );
        })}
    </>
  );
};

ServiceHistory.propTypes = {
  request_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  license: PropTypes.string,
  history_service_request_id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default ServiceHistory;
